import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { css } from "styled-components";

pageHeaderStyles.heading = {
    variant: "h2",
    color: "primary",
    size: "2rem",
    css: css`
        margin-bottom: 0;
    `,
};
